import { graphql } from '../../graphql';

export const createItemMutation = graphql(`
  mutation CreateItem(
    $area: ItemCreateAreaInput!
    $buildingType: ItemCreateBuildingTypeEnum
    $categoryId: ID!
    $contact: ItemCreateContactInput!
    $description: String
    $floor: ItemCreateFloorInput
    $hasBillOfSale: Boolean
    $hasMortgage: Boolean
    $hasRepair: Boolean
    $isLeased: Boolean!
    $location: ItemCreateLocationInput!
    $paidDaily: Boolean
    $photoIds: [ID!]!
    $price: Int!
    $rooms: Int
  ) {
    createItem(
      input: {
        area: $area
        buildingType: $buildingType
        categoryId: $categoryId
        contact: $contact
        description: $description
        floor: $floor
        hasBillOfSale: $hasBillOfSale
        hasMortgage: $hasMortgage
        hasRepair: $hasRepair
        isLeased: $isLeased
        location: $location
        paidDaily: $paidDaily
        photoIds: $photoIds
        price: $price
        rooms: $rooms
      }
    ) {
      status
      item {
        id
      }
      errors {
        code
        message
        path
      }
    }
  }
`);

export const updateItemMutation = graphql(`
  mutation UpdateItem(
    $area: ItemUpdateAreaInput
    $contactName: String
    $description: String
    $floor: ItemUpdateFloorInput
    $hasBillOfSale: Boolean
    $hasMortgage: Boolean
    $hasRepair: Boolean
    $itemId: ID!
    $paidDaily: Boolean
    $photoIds: [ID!]
    $price: Int
    $rooms: Int
    $location: ItemUpdateLocationInput
  ) {
    updateItem(
      input: {
        area: $area
        contactName: $contactName
        description: $description
        floor: $floor
        hasBillOfSale: $hasBillOfSale
        hasMortgage: $hasMortgage
        hasRepair: $hasRepair
        itemId: $itemId
        paidDaily: $paidDaily
        photoIds: $photoIds
        price: $price
        rooms: $rooms
        location: $location
      }
    ) {
      status
      item {
        id
      }
      lockedUntil
      errors {
        code
        message
        path
      }
    }
  }
`);

export const prolongItemMutation = graphql(`
  mutation ProlongItem($itemId: ID!) {
    prolongItem(input: { itemId: $itemId }) {
      item {
        id
        state
      }
      errors {
        code
        message
        path
      }
    }
  }
`);

export const payForItemMutation = graphql(`
  mutation PayForItem($itemId: ID!) {
    payForItem(input: { itemId: $itemId }) {
      item {
        id
        state
      }
      errors {
        code
        message
        path
      }
    }
  }
`);

export const deleteItemMutation = graphql(`
  mutation DeleteItem($itemId: ID!) {
    deleteItem(input: { itemId: $itemId }) {
      item {
        id
        state
      }
      errors {
        code
        message
        path
      }
    }
  }
`);
